import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const MaterialSchema = (localeCodes) =>
  Yup.object().shape({
    code: Yup
      .string()
      .label("Code")
      .required()
      .max(50),
      localizations: createLocalizationsSchema(localeCodes),
  });

export default MaterialSchema;
